import React from 'react';
import { Flex, TextV2, TooltipV2, Box } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { Info } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { SkeletonText } from '@shared/components/Skeleton';

export const SpecialEventRatesTag = () => {
  const { tq } = useTranslation('accommodationsConsole');

  return (
    <Flex
      width={'full'}
      justifyContent="center"
    >
      <TooltipV2
        overrides={{
          Content: { props: { paddingY: 4, paddingLeft: pxToRem(14), paddingRight: 4, borderRadius: pxToRem(12), color: 'white', marginLeft: 2 } },
        }}
        content={
          <Flex
            flexDirection="column"
            maxWidth={pxToRem(256)}
          >
            <Box typographyVariant="label3">{tq`Discounted Rates for Joy Guests`}</Box>
            <Box
              typographyVariant="label2"
              color="mono4"
            >
              {tq`Benefit from exclusive rates up to 40% less compared to Expedia.`}
            </Box>
          </Flex>
        }
        placement="top"
        onMouseEnterDelay={500}
      >
        <Flex
          width={'full'}
          gap={3}
          alignItems="center"
          justifyContent="center"
        >
          <TextV2
            color="mono14"
            typographyVariant="button2"
          >
            {tq`Special Event Rates`}
          </TextV2>
          <Info size={16} />
        </Flex>
      </TooltipV2>
    </Flex>
  );
};

SpecialEventRatesTag.Skeleton = () => (
  <Flex
    width={'full'}
    justifyContent="center"
    display={{ _: 'flex', md: 'none' }}
  >
    <Flex
      gap={3}
      width={'full'}
      alignItems="center"
      justifyContent="center"
    >
      <SkeletonText
        rows={1}
        width={200}
        skeletonHeight={24}
      />
      <SkeletonText
        rows={1}
        width={16}
        skeletonHeight={16}
      />
    </Flex>
  </Flex>
);
